import { createStore } from "vuex";

import ProfireLine from "@/store/modules/ProfireLine";
import AuthModule from "@/store/modules/AuthModule";

const store = createStore({
  modules: {
    ProfireLine,
    AuthModule,
  },
});

export default store;
